export const ADVANCED_PROGRAM_TAG_NAME = 'ADVANCED_PROGRAM'
